import { PayloadAction } from '@reduxjs/toolkit';
import { ICountry, StateType } from '.';

export const actions = {
  setCountries: (state: StateType, { payload }: PayloadAction<ICountry[]>) => {
    state.countries = [...payload];
  },
};
